import { BaseSensorWebController } from '../../base/controller/BaseSensorWebController';
import { BaseSensorWebComponent } from '../../base/BaseSensorWebComponent';
import { IntuneSensorComponent } from '../component/IntuneSensorComponent';
import { IntuneSensorView } from '../view/IntuneSensorView';
import { templateIntuneSensor } from '../view/template';
import { IListenerConfig } from '../../../../framework/BaseWebComponentController';

export class IntuneSensorController extends BaseSensorWebController {
  public component: BaseSensorWebComponent;
  public view: IntuneSensorView;
  public viewConstructor: typeof IntuneSensorView;

  constructor(component: IntuneSensorComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: IntuneSensorView,
      viewTemplate: templateIntuneSensor,
    });
  }

  public isSensorEnabled(): boolean {
    return true;
  }

  computeEventListeners(): IListenerConfig[] {
    return super.computeEventListeners().concat([
      {
        element: this.view.dom.$applicationID,
        event: 'change',
        callback: this.inputChanged,
      },
      {
        element: this.view.dom.$tenantID,
        event: 'change',
        callback: this.inputChanged,
      },
      {
        element: this.view.dom.$clientSecret,
        event: 'change',
        callback: this.inputChanged,
      },
    ]);
  }

  public resetData(): void {
    super.resetData();
    this.view.dom.$applicationID.resetField();
    this.view.dom.$tenantID.resetField();
    this.view.dom.$clientSecret.resetField();
  }
}
